import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {useMemo, useState} from 'react';
import React from 'react';
import styles from './timeline-audio-onboarding.module.scss';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Thumbnail} from '@Components/thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {getAssetUrl} from '@Utils/s3.util';
import {showTimelineOnBoarding, toggleTimelineOnBoardingToSeen} from '@Components/poster-editor/library/poster-editor-library';

export function TimelineAudioOnboarding(): ReactElement | null {
  const [isCloseClicked, setIsCloseClicked] = useState(false);

  useEffect(() => {
    return (): void => {
      toggleTimelineOnBoardingToSeen();
      return;
    };
  });

  const onClose = (): void => {
    setIsCloseClicked(true);
    toggleTimelineOnBoardingToSeen();
  };

  const getHeader = (): ReactElement => {
    return (
      <div className={`${styles.header} spacing-p-t-3 spacing-p-l-3 spacing-p-r-3 flex-justify-between flex-items-center`}>
        <Text className="spacing-m-r-2" val={window.i18next.t('pmwjs_timeline_onboarding_header_text')} bold size={TextSize.XSMALL} />
        <Icon shape={IconShape.SQUARE} type={IconType.TRANSPARENT} onClick={onClose} className="_cursor-pointer" icon="icon-close" size={IconSize.SIZE_ICON_16} />
      </div>
    );
  };

  const getContent = (): ReactElement => {
    return (
      <>
        <div className={`spacing-p-l-2 spacing-p-t-2 ${styles.thumbContainer}`}>
          <Thumbnail
            className={styles.thumb}
            data={{
              type: ThumbnailType.IMAGE,
              imageSrc: getAssetUrl('timeline-onboarding-thumbnail.webp '),
            }}
          />
        </div>
        <div className="spacing-p-r-4 spacing-p-l-4 spacing-p-t-0 spacing-p-b-3">
          <Text dangerouslySetInnerHTML size={TextSize.XXSMALL} val={window.i18next.t('pmwjs_timeline_onboarding_text')} />
        </div>
      </>
    );
  };

  return useMemo((): ReactElement | null => {
    if (!showTimelineOnBoarding()) {
      return null;
    }
    return (
      <div className="_full-height flexbox flex-align-items-end">
        <div className={`_full-width _fit-height ${styles.container} flex-v-row radius-8`}>
          {getHeader()}
          {getContent()}
        </div>
      </div>
    );
  }, [isCloseClicked]);
}
